const TABLE_INNER_CONTENT_HEIGHT = 253;

export const calculateTableHeight = ({
  count,
  defaultHeight,
  limit = 5,
}: {
  count: number;
  defaultHeight?: number;
  limit?: number;
}) => {
  // 5개 이상이면 고정 높이 사용
  if (count > limit) {
    return defaultHeight || TABLE_INNER_CONTENT_HEIGHT;
  }
  // 1개만 있으면 2행 높이, 그 외에는 실제 행 수 + 1
  const rowCount = count === 1 ? 2 : count + 1;
  return 42 * rowCount;
};
